import * as React from 'react'

import FlexView from '@/modules/shared/components/FlexView'
import { formatDurationInHours } from 'app/common/dateHelper'
import { NumericFormat } from 'react-number-format'

export const formatHours = (value: any, translate: any) => {
  return `${formatDurationInHours(value)} ${translate('timeFormat.hours')}`
}

export const formatEditableInt = (
  value: number,
  precision: number,
  onChange: (value: any) => void,
  alignRight: boolean = false,
  stretch: string = '50%',
  height: number = 25,
  fontSize: number = 15,
  width: number = null,
  background: string = '#fff',
  readOnly: boolean = false,
) => {
  return (
    <FlexView
      className="text  tw-flex tw-items-center"
      hAlignContent={alignRight ? 'right' : 'left'}
      style={{ width: width ? width : stretch }}
    >
      <NumericFormat
        className="text-left input"
        disabled={false}
        decimalScale={precision}
        fixedDecimalScale={true}
        value={value}
        readOnly={readOnly}
        style={{
          width: width ? width : stretch,
          fontWeight: 400,
          height: height,
          fontSize: fontSize,
          color: '#454545',
          background: background,
        }}
        onFocus={(element) => {
          element.target.select()
        }}
        onChange={(element) => {
          const value = element.target.value
          onChange && onChange(Number(value))
        }}
      />
    </FlexView>
  )
}
